<div class="container-fluid mt-3 ">
    <div class="row">
        <mat-form-field class="col-12">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="Model.Code" placeholder="Code" disabled>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Heure de prélèvement</mat-label>
            <input matInput [ngxTimepicker]="timepicker" [value]="samplingTime" [format]="24" readonly>
            <ngx-material-timepicker #timepicker (timeSet)="timeSetSamplingDate($event)"></ngx-material-timepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Localisation</mat-label>
            <input matInput [(ngModel)]="Model.Localisation" placeholder="Localisation">
        </mat-form-field>
        <!-- <mat-form-field class="col-12">
            <mat-label>Référence Etiquette</mat-label>
            <input matInput [(ngModel)]="Model.ReferenceEtiquette" placeholder="Référence Etiquette">
        </mat-form-field> -->
        <mat-form-field class="col-12">
            <mat-label>Matériel Scola</mat-label>
            <input matInput [(ngModel)]="Model.ScolaMaterial" placeholder="Matériel Scola">
        </mat-form-field>
        <mat-checkbox [(ngModel)]="Model.PrelevementEffectue"> Prélèvement Effectué</mat-checkbox>

        <mat-form-field class="col-12">
            <mat-select placeholder="Processus lié" [(ngModel)]="Model.ProcessMesureTerrainCode" required>
                @for (o of AvailableMeasureOnThisInterventionList; track o; ) {
                <mat-option [value]="o.mrCode">
                    <span>{{o.mrName}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>